import { Injectable } from '@angular/core';

/**
 * Servicio para gestionar el Device ID único de cada instalación
 * Este ID identifica qué archivos fueron creados en este equipo específico
 */
@Injectable({
  providedIn: 'root',
})
export class DeviceIdService {
  private readonly STORAGE_KEY = 'app_device_id';
  private readonly STORAGE_KEY_CREATED = 'app_device_id_created';
  private deviceId: string | null = null;

  /**
   * Obtiene o genera el Device ID único de este equipo
   * El ID se genera una sola vez y se persiste en localStorage
   */
  getDeviceId(): string {
    if (this.deviceId) {
      return this.deviceId;
    }

    // Intentar cargar de localStorage
    const stored = localStorage.getItem(this.STORAGE_KEY);

    if (stored) {
      this.deviceId = stored;
      console.log('✅ Device ID cargado:', this.deviceId);
      return this.deviceId;
    }

    // Generar nuevo Device ID usando timestamp + random
    this.deviceId = this.generateDeviceId();
    localStorage.setItem(this.STORAGE_KEY, this.deviceId);
    localStorage.setItem(this.STORAGE_KEY_CREATED, new Date().toISOString());

    console.log('🆕 Device ID generado:', this.deviceId);

    return this.deviceId;
  }

  /**
   * Verifica si un archivo pertenece a este equipo
   */
  isOwnFile(fileDeviceId: string): boolean {
    return fileDeviceId === this.getDeviceId();
  }

  /**
   * Obtiene información del dispositivo
   */
  getDeviceInfo(): { id: string; createdAt: string | null } {
    const id = this.getDeviceId();
    const createdAt = localStorage.getItem(this.STORAGE_KEY_CREATED);

    return { id, createdAt };
  }

  /**
   * Limpia el Device ID (solo para testing o reinstalación manual)
   */
  clearDeviceId(): void {
    localStorage.removeItem(this.STORAGE_KEY);
    localStorage.removeItem(this.STORAGE_KEY_CREATED);
    this.deviceId = null;
    console.log('🗑️ Device ID eliminado');
  }

  /**
   * Genera un Device ID único basado en timestamp + random
   */
  private generateDeviceId(): string {
    const timestamp = Date.now();
    const random = Math.random().toString(36).substring(2, 15);
    return `device-${timestamp}-${random}`;
  }
}
